import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function AboutPage() {
  const [showPage, setShowPage] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowPage(true), 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`min-h-screen bg-gradient-to-b from-amber-50 to-white transition-opacity duration-1000 ${
      showPage ? 'opacity-100' : 'opacity-0'
    }`}>
      {/* Navigation */}
      <nav className="flex items-center justify-between p-6 max-w-6xl mx-auto">
        <Link to="/" className="text-amber-950 font-light text-2xl hover:text-amber-900 transition-colors">
          veyebe
        </Link>
        <Link to="/" className="flex items-center gap-2 text-amber-900 hover:text-amber-950 transition-colors">
          <ArrowLeft size={20} />
          Back
        </Link>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className={`mb-12 transition-all duration-1000 delay-100 ${
          showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <h1 className="text-5xl md:text-6xl font-light text-amber-950 mb-8">About veyebe</h1>
          
          <div className={`space-y-6 text-amber-900 font-light text-lg leading-relaxed transition-all duration-1000 delay-300 ${
            showPage ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}>
            <p>
              veyebe is a habit-tracking platform built with the belief that small, consistent actions lead to remarkable life transformations. We're dedicated to helping people build better habits and achieve their goals through technology that's intuitive, elegant, and genuinely helpful.
            </p>
            
            <h2 className="text-3xl font-light text-amber-950 mt-8 mb-4">Our Mission</h2>
            <p>
              We believe that building your future starts with understanding that meaningful change happens one day at a time. Our mission is to make habit-building accessible, enjoyable, and sustainable for everyone.
            </p>
            
            <h2 className="text-3xl font-light text-amber-950 mt-8 mb-4">Our Values</h2>
            <ul className="space-y-3">
              <li className="flex gap-3">
                <span className="text-amber-950 font-normal">•</span>
                <span><strong className="font-normal text-amber-950">Simplicity:</strong> Complex problems deserve elegant solutions</span>
              </li>
              <li className="flex gap-3">
                <span className="text-amber-950 font-normal">•</span>
                <span><strong className="font-normal text-amber-950">Consistency:</strong> We champion the power of daily progress</span>
              </li>
              <li className="flex gap-3">
                <span className="text-amber-950 font-normal">•</span>
                <span><strong className="font-normal text-amber-950">Community:</strong> Together, we achieve more than we can alone</span>
              </li>
              <li className="flex gap-3">
                <span className="text-amber-950 font-normal">•</span>
                <span><strong className="font-normal text-amber-950">Impact:</strong> We measure success by the positive changes in our users' lives</span>
              </li>
            </ul>

            <h2 className="text-3xl font-light text-amber-950 mt-8 mb-4">Our Founder</h2>
            <p>
              veyebe is a technical passion project created to explore how thoughtful design and technology can support personal growth. Matthew started out with just an Excel sheet in 2025, but since then veyebe has evolved into a modern web and mobile application for meaningful change.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
